// export const API_URL = process.env.REACT_APP_ADMIN_API_URL;
export const API_URL = process.env.REACT_APP_API_URL;
export const DEALER_URL = process.env.REACT_APP_DEALER_URL;
export const SERVICE_HISTORY_URL = process.env.REACT_APP_SERVICE_HISTORY_URL;
export const INVENTORY_URLS = process.env.REACT_APP_INVENTORY_URL;
export const CSV_LEAD_URLS = process.env.REACT_APP_DEALER_LEAD_URL;
export const CENTRAL_URLS = process.env.REACT_APP_CENTRAL_SERVICE_URL;
export const ADMIN_APIKEY = process.env.REACT_APP_ADMIN_APIKEY;
export const DC_APIKEY = process.env.REACT_APP_DC_APIKEY;
export const DEFAULT_DEALER_ID = process.env.REACT_APP_DEFAULT_DEALER_ID;
export const PAYMENT_API_KEY = process.env.REACT_APP_NEST_API_URL;
export const AUCTION_URL = process.env.REACT_APP_AUCTION_URL;
export const PRICE_API_URL = process.env.REACT_APP_PRICE_API_URL;
export const FCM_URL = process.env.REACT_APP_CENTRAL_SERVICE_URL;

// WhatsApp chat (Service/the-motorpedia-services → /api/v1/whatsapp) and its
// Socket.IO origin. Read through a guard because vite.config.js only injects
// `process.env.REACT_APP_*` keys that actually exist in the env file — an
// absent key leaves a bare `process` reference that throws in the browser.
const readEnv = (read) => {
  try {
    return read();
  } catch {
    return undefined;
  }
};

export const WHATSAPP_API_URL =
  readEnv(() => process.env.REACT_APP_WHATSAPP_API_URL) || "https://dealer-service.themotorpedia.com";
export const WHATSAPP_SOCKET_URL =
  readEnv(() => process.env.REACT_APP_WHATSAPP_SOCKET_URL) || "https://dealer-auction-service.themotorpedia.com";
